module.exports = "/assets/data/bedf5013c27dfe63760af7df4f126b0b-GU1.data.json";